import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const ColorCircularProgress = withStyles({
  root: {
    color: '#3b5998',
  },
})(CircularProgress);
  
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    textAlign: 'center',
  },
  margin: {
    margin: theme.spacing(1),
  },
  margenesDescripcion:{
    paddingTop: '5px',
    paddingBottom: '20px',
  }
}));

export default function LoadingIndicator() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ColorCircularProgress size={60} thickness={5} />
      <div className={classes.margenesDescripcion}>
        <strong>Cargando datos ...</strong>        
      </div>
    </div>
  );
}